import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import { Link, NavLink } from 'react-router-dom';
import CurrencySwitcher from 'app/components/ui/CurrencySwitcher';
import Button from 'app/components/ui/Button';
import { ReactComponent as QuipuswapLogoMobile } from 'app/components/svg/QuipuswapLogoMobile.svg';
import { ReactComponent as QuipuSwapLogoMobileWithText } from 'app/components/svg/QuipuSwapLogoMobileWithText.svg';
import { AppRoutes } from 'app/static/routes/routes-enum';
import { withCloseByEmptySpace } from 'app/utils/withCloseByEmptySpace';
import { CloseByEmptySpaceType } from 'app/types/close-by-empty-space';
import Burger from 'app/components/ui/Burger';
import { menuList } from 'app/components/common/Sidebar/content';
import { ReactComponent as Search } from 'app/components/svg/SearchIcon.svg';
import InputSearch from 'app/components/common/InputSearch';
import { useWindowSize } from 'app/utils/windowResize';
import { MOBILE_WIDTH } from 'app/utils/defaults';

import s from './HeaderMobile.module.sass';

const HeaderMobile: React.FC<CloseByEmptySpaceType> = ({
  dropdownRef,
  selectRef,
  active,
  handleSwitchDropdown,
}) => {
  const { width } = useWindowSize();
  const [activeSearch, setActiveSearch] = useState<boolean>(false);

  const handleSwitchSearch = () => {
    setActiveSearch(!activeSearch);
  };

  useEffect(() => {
    if (activeSearch && active) {
      setActiveSearch(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  const isMobile = width <= MOBILE_WIDTH;

  return (
    <div className={cx(s.mobile, { [s.activeSearch]: activeSearch })}>
      <div className={cx(s.header)}>
        <div className={cx(s.mobileWrapper)}>
          <Link to={AppRoutes.OVERVIEW} className={cx(s.link)}>
            {isMobile ? <QuipuswapLogoMobile /> : <QuipuSwapLogoMobileWithText />}
          </Link>

          <CurrencySwitcher className={cx(s.switcher)} />

          <Button
            sizeT="small"
            theme="clear"
            onClick={handleSwitchSearch}
            className={cx(s.searchButton)}
          >
            <Search className={cx(s.search)} />
          </Button>

          <Button
            sizeT="small"
            theme="clear"
            onClick={handleSwitchDropdown}
          >
            <Burger opened={active} ref={selectRef} />
          </Button>
        </div>

        <InputSearch className={cx(s.inputSearch)} isBurgerActive={active} />

        <div className={cx(s.dropdown, { [s.active]: active })} ref={dropdownRef}>
          {
            menuList.length && (
              <nav className={cx(s.list)}>
                {
                  menuList.map(({
                    item, to, id, Icon,
                  }) => (
                    <NavLink
                      to={to}
                      key={id}
                      className={cx(s.item)}
                      activeClassName={cx(s.active)}
                    >
                      <div className={cx(s.icon)}>
                        <Icon />
                      </div>

                      {item}
                    </NavLink>
                  ))
                }
              </nav>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default withCloseByEmptySpace(HeaderMobile);
